import React from "react";

const HeadBody = ({ name, email, phoneNumber, inn }) => (
    <div className="profile-head__data">
        <div className="profile-head__data-name">
            {name}
            {inn && (
                <>
                    <br />
                    <small className="font-size-14">ИНН: {inn}</small>
                </>
            )}
        </div>
        <div className="profile-head__data-contacts">
            <span>{email}</span>
            <span>{phoneNumber}</span>
        </div>
    </div>
);

export { HeadBody };
